/*
SLB GENERATED FILE — DO NOT EDIT
Project: Saam Law BaseStation (SLB)
Build-Version: SLB_V4_133_JEE_CHAT_TRANSACTION_CONSOLE_20260910_01
Output: assets/slb.std-editor.v1.js
Source: slb_src/slices/std_editor_v1/
Build: slb_build/build_std_editor_v1.mjs
Built: 2026-09-19 16:54:02.217Z
Content-SHA256: 9d4fdc4270c728ec47c2290724c938acaeadd24117aea8cd2657a90aa5b6eb9e
Content-SHA256-12: 9d4fdc4270c7
*/

/* MIGRATED SOURCE
   Original asset: /assets/slb.std-editor.v1.js
*/

/* SLB Standard Editor (V1)
   Reusable toolbar + contenteditable editor area.

   Features:
   - Stable selection handling (toolbar clicks won't lose cursor)
   - Plain-text paste (avoids messy HTML / unknown tags)
   - Headings, sizes, bold/italic/underline/strike
   - Lists, links, images, YouTube embeds
   - Text color + highlight (quick swatches + color picker)
   - Emoji panel
*/
(function(){
  if(window.SLB_STD_EDITOR_V1) return;

  const MOD = {};

  function $(sel, root){ return (root || document).querySelector(sel); }
  function $all(sel, root){ return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function isEl(x){ return !!(x && x.nodeType === 1); }

  function getAreas(root){
    if(!root) return [];
    let areas = $all('[data-slbeditor-area]', root);
    if(areas && areas.length) return areas;
    areas = $all('.slbStdArea', root);
    if(areas && areas.length) return areas;
    areas = $all('.richEditor', root);
    return areas || [];
  }

  function detectActiveArea(root, areas){
    try{
      const ae = document.activeElement;
      if(!ae) return null;
      for(let i=0;i<areas.length;i++){
        const a = areas[i];
        if(a === ae || (a.contains && a.contains(ae))) return a;
      }
    }catch(_e){}
    return null;
  }

  function getArea(root){
    const areas = getAreas(root);
    if(!areas || areas.length === 0) return null;
    const act = root.__slbStdActiveArea;
    if(act && areas.indexOf(act) !== -1) return act;
    const byFocus = detectActiveArea(root, areas);
    if(byFocus){
      root.__slbStdActiveArea = byFocus;
      return byFocus;
    }
    root.__slbStdActiveArea = areas[0];
    return areas[0];
  }

  function areaContainsRange(area, range){
    if(!area || !range) return false;
    const node = range.commonAncestorContainer;
    if(!node) return false;
    if(node === area) return true;
    return area.contains(node.nodeType === 1 ? node : (node.parentNode || node));
  }

  function saveRange(root){
    try{
      const area = getArea(root);
      const sel = window.getSelection ? window.getSelection() : null;
      if(!area || !sel || sel.rangeCount === 0) return;
      const r = sel.getRangeAt(0);
      if(areaContainsRange(area, r)){
        area.__slbStdSavedRange = r.cloneRange();
        root.__slbStdActiveArea = area;
      }
    }catch(_e){}
  }

  function restoreRange(root){
    try{
      const area = getArea(root);
      const r = area && area.__slbStdSavedRange;
      if(!area || !r) return false;
      if(!areaContainsRange(area, r)) return false;
      const sel = window.getSelection ? window.getSelection() : null;
      if(!sel) return false;
      sel.removeAllRanges();
      sel.addRange(r);
      return true;
    }catch(_e){
      return false;
    }
  }

  function focusAndRestore(root){
    const area = getArea(root);
    if(area){
      try{ area.focus(); }catch(_e){}
    }
    restoreRange(root);
  }

  function esc(s){
    return String(s||'').replace(/[&<>"']/g, m => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;','\'':'&#39;'}[m]));
  }

  function safeUrl(u){
    const s = String(u||'').trim();
    if(!s) return '';
    if(/^https?:\/\//i.test(s)) return s;
    if(/^\/\//.test(s)) return 'https:' + s;
    return '';
  }

  function parseYouTubeId(u){
    const s = String(u||'').trim();
    if(!s) return '';
    // youtu.be/<id>
    let m = s.match(/youtu\.be\/([A-Za-z0-9_-]{6,})/i);
    if(m && m[1]) return m[1];
    // youtube.com/watch?v=<id>
    m = s.match(/[?&]v=([A-Za-z0-9_-]{6,})/i);
    if(m && m[1]) return m[1];
    // youtube.com/embed/<id>
    m = s.match(/youtube\.com\/embed\/([A-Za-z0-9_-]{6,})/i);
    if(m && m[1]) return m[1];
    // shorts
    m = s.match(/youtube\.com\/shorts\/([A-Za-z0-9_-]{6,})/i);
    if(m && m[1]) return m[1];
    return '';
  }

  function exec(cmd, val){
    try{ document.execCommand(cmd, false, val); }catch(_e){}
  }

  function wrapSelectionWithSpan(root, styleObj){
    try{
      const area = getArea(root);
      if(!area) return;
      focusAndRestore(root);

      const sel = window.getSelection ? window.getSelection() : null;
      if(!sel || sel.rangeCount === 0) return;
      const r = sel.getRangeAt(0);
      if(r.collapsed) return;
      if(!areaContainsRange(area, r)) return;

      const span = document.createElement('span');
      Object.keys(styleObj||{}).forEach(k => {
        try{ span.style[k] = styleObj[k]; }catch(_e){}
      });

      const frag = r.extractContents();
      span.appendChild(frag);
      r.insertNode(span);

      // move caret to end
      const nr = document.createRange();
      nr.selectNodeContents(span);
      nr.collapse(false);
      sel.removeAllRanges();
      sel.addRange(nr);
      try{ area.__slbStdSavedRange = nr.cloneRange(); }catch(_e){}
      root.__slbStdActiveArea = area;
    }catch(_e){}
  }

  function applyFontSizePx(root, px){
    const size = String(px||'').trim();
    if(!size) return;
    const n = parseInt(size, 10);
    if(!n) return;

    const areas = getAreas(root);
    if(!areas || areas.length === 0) return;

    // Default readable editor font size (global): 24px
    // (Selection font size dropdown still works; this is just the base for everyday writing.)
    try{
      areas.forEach(a => {
        try{
          if(!a.style.fontSize) a.style.fontSize = '24px';
          if(!a.style.lineHeight) a.style.lineHeight = '1.45';
        }catch(_e0){}
      });
    }catch(_eBase){}
    const area = getArea(root);
    if(!area) return;
    focusAndRestore(root);

    // Use execCommand fontSize to wrap selection, then convert <font> -> <span style="font-size:..">
    exec('fontSize', 7);
    // Convert only within this editor area
    const fonts = $all('font[size="7"]', area);
    fonts.forEach(f => {
      const span = document.createElement('span');
      span.style.fontSize = n + 'px';
      span.innerHTML = f.innerHTML;
      f.parentNode.replaceChild(span, f);
    });
    saveRange(root);
  }


  // ---- Emoji portal (escape stacking contexts / overflow clipping) ----
  function getEmojiPortal_(){
    try{
      const g = window.__SLB_STD_EMOJI_PORTAL_V1 || (window.__SLB_STD_EMOJI_PORTAL_V1 = {});
      if(g.el && document.body && document.body.contains(g.el)) return g;

      const el = document.createElement('div');
      el.className = 'slbEmojiPanel slbEmojiPortal hidden';
      el.setAttribute('data-slb-emoji-portal','1');
      // Inline safety styles (CSS can still style .slbEmojiPanel normally)
      el.style.position = 'absolute';
      el.style.zIndex = '2147483647';
      el.style.left = '0px';
      el.style.top = '0px';
      el.style.maxHeight = '320px';
      el.style.overflowY = 'auto';
      document.body.appendChild(el);

      g.el = el;
      g.activeRoot = null;
      g.activeBtn = null;

      if(!g._bound){
        g._bound = true;

        // Close when clicking outside
        document.addEventListener('mousedown', (e) => {
          try{
            const gg = window.__SLB_STD_EMOJI_PORTAL_V1;
            if(!gg || !gg.el || gg.el.classList.contains('hidden')) return;
            const t = e.target;
            if(t && gg.el.contains(t)) return;
            if(t && gg.activeBtn && (gg.activeBtn === t || (gg.activeBtn.contains && gg.activeBtn.contains(t)))) return;
            gg.el.classList.add('hidden');
            gg.activeRoot = null;
            gg.activeBtn = null;
          }catch(_e){}
        }, true);

        // Scroll/resize tends to desync positioning; safest to close
        window.addEventListener('scroll', () => {
          try{
            const gg = window.__SLB_STD_EMOJI_PORTAL_V1;
            if(gg && gg.el && !gg.el.classList.contains('hidden')){
              gg.el.classList.add('hidden');
              gg.activeRoot = null;
              gg.activeBtn = null;
            }
          }catch(_e){}
        }, true);

        window.addEventListener('resize', () => {
          try{
            const gg = window.__SLB_STD_EMOJI_PORTAL_V1;
            if(gg && gg.el && !gg.el.classList.contains('hidden')){
              gg.el.classList.add('hidden');
              gg.activeRoot = null;
              gg.activeBtn = null;
            }
          }catch(_e){}
        }, true);

        // Handle emoji pick inside portal
        document.addEventListener('click', (e) => {
          try{
            const gg = window.__SLB_STD_EMOJI_PORTAL_V1;
            if(!gg || !gg.el || gg.el.classList.contains('hidden')) return;
            const item = e.target && e.target.closest ? e.target.closest('.slbEmojiItem') : null;
            if(!item || !gg.el.contains(item)) return;

            const ch = item.getAttribute('data-emoji') || '';
            const root = gg.activeRoot;
            if(!root) return;

            focusAndRestore(root);
            exec('insertText', ch);
            gg.el.classList.add('hidden');
            gg.activeRoot = null;
            gg.activeBtn = null;
            saveRange(root);
          }catch(_e){}
        }, true);
      }

      return g;
    }catch(_e){}
    return null;
  }

  function positionEmojiPortal_(portalEl, btn){
    try{
      if(!portalEl || !btn || !btn.getBoundingClientRect) return;
      const r = btn.getBoundingClientRect();

      // show (invisible) for sizing
      portalEl.style.visibility = 'hidden';
      portalEl.classList.remove('hidden');
      portalEl.style.left = '0px';
      portalEl.style.top = '0px';

      const w = portalEl.offsetWidth || 280;
      const h = portalEl.offsetHeight || 240;
      const pad = 8;

      let left = r.left;
      if(left + w + pad > window.innerWidth) left = r.right - w;
      if(left < pad) left = pad;

      let top = r.bottom + 6;
      if(top + h + pad > window.innerHeight) top = Math.max(pad, r.top - h - 6);

      left = left + window.scrollX;
      top = top + window.scrollY;

      portalEl.style.left = Math.round(left) + 'px';
      portalEl.style.top = Math.round(top) + 'px';
      portalEl.style.visibility = 'visible';
    }catch(_e){}
  }

  function toggleEmojiPanel(root, btn){
    try{
      const wrap = (btn && btn.parentNode) ? btn.parentNode : root;
      const panel = wrap ? $('.slbEmojiPanel', wrap) : null;

      const g = getEmojiPortal_();
      if(!g || !g.el) return;

      // close any inline panels inside this editor
      try{ $all('.slbEmojiPanel', root).forEach(p => p.classList.add('hidden')); }catch(_e2){}

      const isOpen = !g.el.classList.contains('hidden') && g.activeRoot === root;
      if(isOpen){
        g.el.classList.add('hidden');
        g.activeRoot = null;
        g.activeBtn = null;
        return;
      }

      // Copy content from the inline panel (template) if available
      if(panel && panel.innerHTML){
        g.el.innerHTML = panel.innerHTML;
      }

      g.activeRoot = root;
      g.activeBtn = btn;

      positionEmojiPortal_(g.el, btn);
    }catch(_e){}
  }

  function closeAllEmojiPanels(root){
    try{ $all('.slbEmojiPanel', root).forEach(p => p.classList.add('hidden')); }catch(_e){}
    try{
      const g = window.__SLB_STD_EMOJI_PORTAL_V1;
      if(g && g.el) g.el.classList.add('hidden');
      if(g){ g.activeRoot = null; g.activeBtn = null; }
    }catch(_e2){}
  }


  function normalizeAlignStyles(area){
    try{
      const els = area.querySelectorAll('[align]');
      els.forEach(el => {
        const a = (el.getAttribute('align') || '').toLowerCase();
        if(a && (a === 'left' || a === 'center' || a === 'right' || a === 'justify')){
          el.style.textAlign = a;
          el.removeAttribute('align');
        }
      });
    }catch(_e){}
  }

  MOD.bind = function(root){
    if(!root || root.__slbStdEditorBound) return;
    root.__slbStdEditorBound = true;

    const areas = getAreas(root);
    if(!areas || areas.length === 0) return;


    // apply fixed height if specified
    try{
      const h = parseInt(root.getAttribute('data-slbeditor-height') || '', 10);
      if(h && h > 0){
        areas.forEach(a => {
          try{
            a.style.minHeight = h + 'px';
            a.style.maxHeight = h + 'px';
            a.style.overflowY = 'auto';
          }catch(_e2){}
        });
      }
    }catch(_e){}
// selection tracking (support multiple areas)
    areas.forEach(a => {
      const track = () => {
        try{ root.__slbStdActiveArea = a; }catch(_e2){}
        saveRange(root);
      };
      ['mousedown','focus','mouseup','keyup','touchend','input'].forEach(ev => {
        try{ a.addEventListener(ev, track); }catch(_e){}
      });
    });

    // plain-text paste (support multiple areas)
    try{
      areas.forEach(a => {
        a.addEventListener('paste', (e) => {
          try{ root.__slbStdActiveArea = a; }catch(_e0){}
          try{ e.preventDefault(); }catch(_e){}
          const cb = (e.clipboardData || window.clipboardData);
          const html = cb ? (cb.getData('text/html') || '') : '';
          const plain = cb ? (cb.getData('text/plain') || cb.getData('text') || '') : '';
          // Rich HTML is accepted only when the shared sanitizer is present and succeeds.
          // Otherwise fail closed to plain text so pasted scripts/styles never enter SLB content.
          if(html){
            let safe = '';
            let sanitized = false;
            try{
              if(window.SLB && window.SLB.sanitize && typeof window.SLB.sanitize.rich === 'function'){
                safe = String(window.SLB.sanitize.rich(html) || '');
                sanitized = true;
              }
            }catch(_eS){
              safe = '';
              sanitized = false;
            }
            if(sanitized){
              try{ document.execCommand('insertHTML', false, safe); }
              catch(_eH){
                try{ document.execCommand('insertText', false, plain); }catch(_e2){ try{ a.textContent += plain; }catch(_e3){} }
              }
            }else{
              try{ document.execCommand('insertText', false, plain); }catch(_e4){ try{ a.textContent += plain; }catch(_e5){} }
            }
          }else{
            try{ document.execCommand('insertText', false, plain); }catch(_e2){ try{ a.textContent += plain; }catch(_e3){} }
          }
          saveRange(root);
        });
      });
    }catch(_e){}
// when toolbar is interacted, remember selection before focus shifts
    try{
      root.addEventListener('mousedown', (e) => {
        const t = e.target;
        if(!t) return;
        if(t.closest && t.closest('.slbWysToolbar')){
          saveRange(root);
          // Prevent buttons from stealing focus / selection
          if(t.closest('button')){
            try{ e.preventDefault(); }catch(_e2){}
          }
        }
      }, true);
    }catch(_e){}



    // --- Toolbar UX normalization (shared across ALL editors)
    // Inject HR (separator line) button + wrap custom color pickers into square buttons
    try{
      // 2) Custom color pickers: make them look like square buttons with a white “?”
      function wrapPicker_(inp){
        try{
          if(!inp || (inp.closest && inp.closest('.slbWysColorBtn'))) return;
          if(inp && inp.closest && inp.closest('#slbDiaryWysToolbar')) return;

          var wrap = document.createElement('span');
          wrap.className = 'slbWysColorBtn';
          var q = document.createElement('span');
          q.className = 'slbWysColorQ';
          q.textContent = '?';
          wrap.appendChild(q);

          // remove inline sizing so CSS controls it
          try{ inp.removeAttribute('style'); }catch(_e0){}
          try{ inp.classList.add('slbWysColorInput'); }catch(_e1){}

          // preserve tooltip on wrapper
          try{ wrap.title = inp.title || inp.getAttribute('title') || ''; }catch(_e2){}
          try{ inp.title = ''; }catch(_e3){}

          var p = inp.parentNode;
          if(!p) return;
          p.insertBefore(wrap, inp);
          wrap.appendChild(inp);
        }catch(_e){}
      }

      try{
        var picks = root.querySelectorAll('input[type="color"][data-wys-colorpicker],input[type="color"][data-wys-hlpicker],input[type="color"][data-wys-colorpick],input[type="color"][data-wys-hlpick]');
        (picks || []).forEach(function(inp){ wrapPicker_(inp); });
      }catch(_ePick){}
    }catch(_eToolbar){}
    // heading / size
    const headingSel = root.querySelector('[data-wys-heading]');
    if(headingSel){
      try{
        headingSel.addEventListener('change', () => {
          const tag = (headingSel.value || 'p').toLowerCase();
          focusAndRestore(root);
          exec('formatBlock', '<' + tag + '>');
          headingSel.blur();
          saveRange(root);
        });
      }catch(_e){}
    }

    const sizeSel = root.querySelector('[data-wys-size]');
    if(sizeSel){
      try{
        sizeSel.addEventListener('change', () => {
          applyFontSizePx(root, sizeSel.value);
          sizeSel.blur();
          saveRange(root);
        });

        // Apply initial default size immediately (so Diary Write doesn't start at 14px).
        try{
          const n0 = parseInt(String(sizeSel.value || '24'), 10) || 24;
          const areas0 = getAreas(root);
          (areas0 || []).forEach(a => {
            try{ a.style.fontSize = n0 + 'px'; }catch(_e0){}
            try{ if(!a.style.lineHeight) a.style.lineHeight = '1.55'; }catch(_e1){}
          });
        }catch(_eInitSize){}
      }catch(_e){}
    }

    const colorPick = root.querySelector('[data-wys-colorpicker],[data-wys-colorpick]') || root.querySelector('input[type="color"]');
    const hlPick = root.querySelector('[data-wys-hlpicker],[data-wys-hlpick]') || (function(){
      const inputs = root.querySelectorAll('input[type="color"]');
      return inputs && inputs.length > 1 ? inputs[1] : null;
    })();

    if(colorPick){
      try{
        colorPick.addEventListener('input', () => {
          wrapSelectionWithSpan(root, { color: colorPick.value });
        });
      }catch(_e){}
    }

    if(hlPick){
      try{
        hlPick.addEventListener('input', () => {
          wrapSelectionWithSpan(root, { backgroundColor: hlPick.value });
        });
      }catch(_e){}
    }

    // main click dispatcher
    root.addEventListener('click', (e) => {
      const t = e.target;
      if(!t) return;

      // emoji item click
      const emojiItem = t.closest && t.closest('.slbEmojiItem');
      if(emojiItem){
        const ch = emojiItem.getAttribute('data-emoji') || '';
        focusAndRestore(root);
        exec('insertText', ch);
        closeAllEmojiPanels(root);
        saveRange(root);
        return;
      }

      // toolbar button
      const btn = t.closest && t.closest('[data-wcmd]');
      if(btn){
        const cmd = btn.getAttribute('data-wcmd') || '';

        // Mobile: toggle extra toolbar tools (used by Diary write)
        if(cmd === 'more'){
          try{
            const on = !root.classList.contains('slbWysMoreOn');
            root.classList.toggle('slbWysMoreOn', on);
            try{ btn.setAttribute('aria-pressed', on ? 'true' : 'false'); }catch(_eA){}
            try{ if(btn && btn.textContent){ btn.textContent = on ? '×' : '⋯'; } }catch(_eT){}
            closeAllEmojiPanels(root);
          }catch(_e){}
          return;
        }

        if(cmd === 'emoji'){
          toggleEmojiPanel(root, btn);
          return;
        }

        if(cmd === 'yt'){
          const u = prompt('Paste YouTube link:');
          const id = parseYouTubeId(u);
          if(!id){ alert('Invalid YouTube link.'); return; }
          const src = 'https://www.youtube.com/embed/' + id;
          const html = '<div class="slbYtEmbed"><iframe src="' + src + '" title="YouTube video" frameborder="0" loading="lazy" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe></div>';
          focusAndRestore(root);
          exec('insertHTML', html);
          saveRange(root);
          return;
        }

        if(cmd === 'insertImage'){
          const u = prompt('Paste image URL (https://...)');
          const url = safeUrl(u);
          if(!url){ alert('Invalid image URL.'); return; }
          const html = '<img src="' + esc(url) + '" alt="" />';
          focusAndRestore(root);
          exec('insertHTML', html);
          saveRange(root);
          return;
        }

        if(cmd === 'createLink'){
          const u = prompt('Paste link URL (https://...)');
          const url = safeUrl(u);
          if(!url){ alert('Invalid link URL.'); return; }
          focusAndRestore(root);
          exec('createLink', url);
          saveRange(root);
          return;
        }

        if(cmd === 'quote'){
          focusAndRestore(root);
          try{ document.execCommand('formatBlock', false, 'BLOCKQUOTE'); }catch(_e){}
          normalizeAlignStyles(getArea(root));
          saveRange(root);
          return;
        }

        // alignment commands -> normalize align attrs
        if(cmd === 'justifyLeft' || cmd === 'justifyCenter' || cmd === 'justifyRight' || cmd === 'justifyFull'){
          focusAndRestore(root);
          exec(cmd);
          normalizeAlignStyles(getArea(root));
          saveRange(root);
          return;
        }

        // default
        focusAndRestore(root);
        exec(cmd);
        normalizeAlignStyles(getArea(root));
        closeAllEmojiPanels(root);
        saveRange(root);
        return;
      }

      // quick color swatch
      const sw = t.closest && t.closest('[data-wcolor]');
      if(sw){
        const c = sw.getAttribute('data-wcolor');
        if(c) wrapSelectionWithSpan(root, { color: c });
        saveRange(root);
        return;
      }

      // quick highlight swatch
      const bg = t.closest && t.closest('[data-wbg]');
      if(bg){
        const c = bg.getAttribute('data-wbg');
        if(c) wrapSelectionWithSpan(root, { backgroundColor: c });
        saveRange(root);
        return;
      }

      // outside clicks inside root close emoji panels
      if(t.closest && t.closest('.slbStdEditor')){
        if(!t.closest('.slbEmojiWrap')) closeAllEmojiPanels(root);
      }
    });
  };

  MOD.autoBind = function(){
    try{
      $all('.slbStdEditor[data-slbeditor="v1"]').forEach(el => MOD.bind(el));
    }catch(_e){}
  };

  window.SLB_STD_EDITOR_V1 = MOD;

  // Defer auto-bind if script is loaded with defer
  try{
    if(document.readyState === 'loading'){
      document.addEventListener('DOMContentLoaded', () => { try{ MOD.autoBind(); }catch(_e){} });
    }else{
      MOD.autoBind();
    }
  }catch(_e){}
})();

